import { NavigateOptions } from "react-router-dom";

const History = {
  navigate: (page: string, options?: NavigateOptions) => {},
  push: (page: string, ...rest: [NavigateOptions]) => History.navigate(page, ...rest),
};

export default History;